<div class="mat-typography analysis">
  <div class="analysis-left">
    <div class="analysis-image info-block">
            <div class="image-container" [ngClass]="{
            'point-image': isPoint
            }">
        <img [src]="this.data.image" alt="analysis-map">
        <!--                <div class="icon icon-zoom-in open-full" (click)="openImage(fullImage)"></div>-->
      </div>
      @if (mapLayer) {
        <div class="legend-info">
          @if (!isLinearLayer(mapLayer)) {
            <div class="visual-progress"
            [style.background]="getGradientBackground(mapLayer)"></div>
          }
          @if (isLinearLayer(mapLayer)) {
            <div class="visual-progress discrete">
              @for (color of getDiscreteColors(mapLayer); track color) {
                <span
                [style.background-color]="color"></span>
              }
            </div>
          }
          <div class="legend-container">
            <div class="legends" [class.numeric]="isNumeric(getLayerLegends(mapLayer)[0])">
              @if (isNumeric(getLayerLegends(mapLayer)[0])) {
                @for (legend of getSpacedNumericLegends(mapLayer); track legend; let i = $index) {
                  <span
                    class="legend" [style.left.%]="i * (100 / (getLayerLegends(mapLayer).length - 1))"
                    [style.transform]="'translateX(-' + (i * (100 / (getLayerLegends(mapLayer).length - 1))) + '%)'"
                  [title]="legend">{{ formatLegend(legend, mapLayer.layer.name) }}</span>
                }
              } @else {
                @for (legend of getLayerLegends(mapLayer); track legend) {
                  <span class="legend"
                  [title]="legend">{{ formatLegend(legend, mapLayer.layer.name) }}</span>
                }
              }
            </div>
          </div>
        </div>
      }
    </div>
  </div>
  <div class="analysis-container">
    <div class="info-analysis-block">
      @if (mapLayer?.layer.name !== 'Exposure' && calculateExposureValue()) {
        <ng-template [ngTemplateOutlet]="summaryCard"
                         [ngTemplateOutletContext]="{
                                     value: calculateExposureValue(),
                                             title: 'AOI Exposure',
                                             shadow: true
                                     }">
        </ng-template>
      }
      <ng-template [ngTemplateOutlet]="summaryCard"
                         [ngTemplateOutletContext]="{
                                     value: calculateValueLabel(this.data, layer?.layerInfo),
                                             title: layerValuePrefix(layer?.layerInfo) + layerLabelTransform(layer?.layer_name)+' Value of AOI',
                                             shadow: true
                                     }">
      </ng-template>
      @if (!isLinearLayer(mapLayer)) {
        <ng-template [ngTemplateOutlet]="summaryCard"
                         [ngTemplateOutletContext]="{
                                     value: calculateThreshold(mapLayer),
                                             title: selectionLabel(layer?.layerInfo),
                                             shadow: true
                                     }">
        </ng-template>
      }
      @if (isLinearLayer(mapLayer)) {
        <div class='summary-card shadowed'>
          <div class="card-info">
            <p class="card-reading reading-with-tooltip" [matTooltip]="calculateThreshold(mapLayer)?.join(', ')" [matTooltipDisabled]="calculateThreshold(mapLayer)?.length <= 1"
              matTooltipPosition="above" matTooltipClass="threshold-tooltip">
              <span>
                {{calculateThreshold(mapLayer)?.length > 1 ? 'Selected Criteria' :  calculateThreshold(mapLayer)?.join(', ')}}
              </span>
              <!--                        <span class="icon icon-info" *ngIf="calculateThreshold(mapLayer)?.length > 1" ></span>-->
              @if (calculateThreshold(mapLayer)?.length > 1) {
                <inline-svg src="info.svg"  color="#85BBF3" class="info-icon">  </inline-svg>
              }
            </p>
            @if (calculateThreshold(mapLayer)?.length <= 1) {
              <p class="card-title">{{ selectionLabel(layer?.layerInfo) | translate }}</p>
            }
          </div>
        </div>
      }
    </div>
    <div class="data-block">
      <div id="chart" class="info-block">
        <div class="chart-title">{{ layerLabelTransform(layer?.layer_name) }}
          Value {{ createExposureExplanation(layer?.layer_name) }}
        </div>
        <apx-chart
          #chartAPXExp
          [series]="chartOptions.series"
          [chart]="chartOptions.chart"
          [dataLabels]="chartOptions.dataLabels"
          [plotOptions]="chartOptions.plotOptions"
          [yaxis]="chartOptions.yaxis"
          [xaxis]="chartOptions.xaxis"
          [fill]="chartOptions.fill"
          [title]="chartOptions.title"
          [noData]="chartOptions.noData"
          [tooltip]="chartOptions.tooltip"
          [states]="chartOptions.states"
        ></apx-chart>
      </div>
      <!--            <div id="chartFire" class="info-block">-->
      <!--                <div class="chart-title">Fire History (Last 50 years)</div>-->
      <!--                <apx-chart #chartAPX-->
      <!--                        [series]="chartFireOptions.series"-->
      <!--                        [chart]="chartFireOptions.chart"-->
      <!--                        [dataLabels]="chartFireOptions.dataLabels"-->
      <!--                        [plotOptions]="chartFireOptions.plotOptions"-->
      <!--                        [yaxis]="chartFireOptions.yaxis"-->
      <!--                        [xaxis]="chartFireOptions.xaxis"-->
      <!--                        [fill]="chartFireOptions.fill"-->
      <!--                        [title]="chartFireOptions.title"-->
      <!--                        [tooltip]="chartFireOptions.tooltip"-->
    <!--                ></apx-chart>-->
  <!--            </div>-->
</div>
</div>
</div>

<ng-template #summaryCard let-value="value" let-title="title" let-icon="icon" let-shadow='shadow'>
  <div [ngClass]="shadow ? 'summary-card shadowed': 'summary-card'">
    <div class="card-info">
      <p class="card-reading" [innerHTML]="value"></p>
      <p class="card-title">{{ title | translate }}</p>
    </div>
    @if (icon) {
      <div class="card-icon">
        <img [src]="icon" alt="icon"/>
      </div>
    }
  </div>
</ng-template>

<ng-template #fullImage>
  <div class="image-container">
    <img [src]="this.data.image" alt="analysis-map" class="analysis-map">
    <div class="icon icon-small-close close-full" (click)="colapseImage()"></div>
  </div>
</ng-template>

